export default 'realityCheck';
